<template>
  <div class="main-content">
    <NavBar v-if="!userRelated" />
    <DashboardNav v-else />
    <RouterView />
    <FooterArea />
  </div>
</template>

<script>
import DashboardNav from "./components/DashboardNav.vue";
import FooterArea from "./components/FooterArea.vue";
import NavBar from "./components/NavBar.vue";

export default {
  name: "App",
  components: {
    NavBar,
    DashboardNav,
    FooterArea,
  },
  data() {
    return {
      userRelated: false,
    };
  },
  created() {
    this.getCurrentPage();
  },
  methods: {
    getCurrentPage() {
      const currentPath = this.$router.history.current.path.substring(1);
      if (
        currentPath.startsWith("dashboard") ||
        currentPath.startsWith("login")
      ) {
        this.userRelated = true;
      } else {
        this.userRelated = false;
      }
    },
  },
  watch: {
    $route() {
      const currentPath = this.$router.history.current.path.substring(1);
      if (
        currentPath.startsWith("dashboard") ||
        currentPath.startsWith("login")
      ) {
        this.userRelated = true;
      } else {
        this.userRelated = false;
      }
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style>
body {
  font-family: "Poppins", sans-serif;
  display: flex;
  justify-content: center;
  background: linear-gradient(270deg, #c4fff7 -26.45%, #cde1ff 109.06%);
  min-height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none !important;
}
.main-content {
  width: 100% !important;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.content {
  width: 100%;
}
.bg-green {
  background-image: url("assets/bg-green.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-green2 {
  background-image: url("assets/bg-green2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-green3 {
  background-image: url("assets/bg-green3.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.footer {
  background-color: #3b3e51;
  width: 100%;
  margin: 0;
  padding: 1rem;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.one-column-view {
  padding: 80px 1rem 3rem;
}
.two-column-view {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 80px 1rem 3rem;
  .left-side-column,
  .right-side-column {
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    .column-image {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
.article-content {
  text-align: start;
  h1 {
    color: #ef8200;
    font-weight: 700;
    font-size: 1.5rem;
  }
  p {
    color: #3b3e51;
    font-weight: 400;
    font-size: 0.95rem;
    line-height: 1.4rem;
    margin-bottom: 2rem;
  }
  h5 {
    color: #ef8200;
    font-weight: 700;
    font-size: 0.95rem;
    line-height: 1.4rem;
  }
  img {
    width: 90%;
    margin: 0 auto 3rem;
    display: block;
  }
  .w-35 {
    width: 35% !important;
  }
  .w-65 {
    width: 65% !important;
  }
}
.color-gold {
  color: #ee8709 !important;
}
.color-blue {
  color: #3586CB !important;
}
.btn-gold {
  background-color: #ef8200 !important;
  border: none !important;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .content {
    width: 100% !important;
  }
  .article-content {
    .w-md-25 {
      width: 25% !important;
    }
    .w-md-35 {
      width: 35% !important;
    }
    .w-md-50 {
      width: 50% !important;
    }
    .w-md-65 {
      width: 65% !important;
    }
    .w-md-75 {
      width: 75% !important;
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .content {
    width: 100% !important;
  }
  .article-content {
    .w-lg-35 {
      width: 35% !important;
    }
    .w-lg-65 {
      width: 65% !important;
    }
  }
  .two-column-view {
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;
    .article-content {
      width: 60%;
      padding: 0 1rem;
    }
    .left-side-column,
    .right-side-column {
      width: 40%;
      padding: 0 1rem;
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content {
    width: 1200px;
    max-width: 1200px;
  }
  .article-content {
    .w-xl-35 {
      width: 35% !important;
    }
    .w-xl-65 {
      width: 65% !important;
    }
  }
  .one-column-view,
  .two-column-view {
    padding: 3rem;
  }
}
</style>
